import { render, staticRenderFns } from "./StopPI_Items.vue?vue&type=template&id=180afa59"
import script from "./StopPI_Items.vue?vue&type=script&lang=js"
export * from "./StopPI_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports